import React from 'react';
import { useMediaQuery } from 'react-responsive';

import './footer.scss';
import duduLogo from '../../assets/DuduLogo.svg';
import { IoMdArrowUp } from "react-icons/io";



export default function Footer({ scrollToHeader }) {
    const isMediumScreen = useMediaQuery({ query: '(max-width: 850px)' });
    const isAlmostMediumScreen = useMediaQuery({ query: '(max-width: 1212px)' });


    return (
        <section className='footer' style={{

        }}>
            <div style={{ display: 'flex', flexDirection: isAlmostMediumScreen ? 'column' : 'row', justifyContent: 'space-between' }}>
                <div style={{ marginBottom: '60px' }}>
                    <img style={{ cursor: 'pointer', marginBottom: '30px', }} src={duduLogo} alt="regular dudu world logo" />
                    <p style={{ color: '#C3A397', width: isMediumScreen ? '90%' : '50%', lineHeight: '24px', fontSize: '18px' }}>We aim at bringing our clients dreams and ideas to life,
                        through creating artful & innovative memorable experiences.</p>
                </div>
                <div style={{ display: 'flex', gap: isMediumScreen ? '60px' : '170px', flexDirection: isMediumScreen ? 'column' : 'row' }}>
                    <div style={{ display: 'flex', gap: '170px' }}>
                        <ul style={{ display: 'flex', flexDirection: 'column', gap: isMediumScreen ? '17px' : '20px', whiteSpace: 'nowrap' }}>
                            <p>Menu</p>
                            <a href='/'>Home</a>
                            <a href='/about'>About Us</a>
                            <a href='/loadgallery'>Gallery</a>
                            <a href='/explore'>Explore</a>
                            <a href='/contact'>Contact</a>
                        </ul>
                        <ul style={{ display: 'flex', flexDirection: 'column', gap: '20px', whiteSpace: 'nowrap' }}>
                            <p >Socials</p>
                            <a href='https://www.instagram.com/dudus_world_of_ent?igsh=bWsyeGhhdWdobjV4'>Instagram</a>
                            <a href='https://www.facebook.com/dudusworld1?mibextid=LQQJ4d'>Facebook</a>
                            <a href='https://wa.link/kfl8l4 '>Whatsapp</a>
                        </ul>
                    </div>
                    <div style={{ width: '209px', display: isMediumScreen ? 'block' : 'inline' }}>
                        <p style={{ marginBottom: isMediumScreen ? '15px' : '30px', color: '#916859', fontSize: '18px', lineHeight: '21px', }}>Address</p>
                        <p style={{ color: '#C3A397', }}>
                            170 Fairview Mall Drive,
                            <span style={{ display: 'block', marginTop: '20px' }}>
                                Toronto, Ontario, Canada.
                            </span>
                        </p>
                    </div>
                </div>

            </div>
            <hr style={{ height: '1px', background: '#DED4CE', marginBottom: '40px', marginTop: isMediumScreen ? '97px' : '200px', opacity: .6 }} />
            {!isMediumScreen && <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', lineHeight: '21px', fontSize: '18px', fontWeight: 400, color: '#916859' }}>
                <p>Copyright © 2024 Dudu&apos;s World of Entertainment. All rights reserved.</p>
                <a href='#header' style={{ textDecoration: 'none', }}><p style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '2px', }}><span >Back to top</span>
                    <span style={{ height: 'fit-content', padding: 0, }}><IoMdArrowUp style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }} /></span>
                </p></a>
            </div>}
            {isMediumScreen && <div style={{ gap: '25px', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', lineHeight: '21px', fontSize: '14px', fontWeight: 400, color: '#916859', flexDirection: 'column' }}>
                <a href='#header'><div onClick={scrollToHeader} style={{ cursor: 'pointer', padding: '11px', border: 'solid 1px #916859', borderRadius: '50%' }}>
                    <IoMdArrowUp style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px', color: '' }} />
                </div>
                </a>
                <p style={{ textAlign: 'center' }}>Copyright © 2024 Dudu&apos;s World of Entertainment. All rights reserved.</p>
            </div>}
        </section>
    )
}